// Calendar.js

// import React...
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { updateSchedule } from '../actions/calendar-actions';
 
// ... and fullcalendar-reactwrapper.
import FullCalendar from 'fullcalendar-reactwrapper';


class Calendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        eventSources:[
/*            {
                url: 'http://beisekerice.com/rest/calendar.php',
                type: 'GET'

                //default anonymous will have read-only access (no Authorization header)
            },*/
            {
//                url: '/api/v0/calendar',
                url: 'https://beisekerice.com/api/v0/calendar',
//                  url: 'http://localhost:3001/api/v0/calendar',
                type: 'GET'
            }

        ]
      }
    };

    handleEventClick(event) {
        //this.props.onUpdateCalendar(event.start.format(), 'agendaWeek');
        this.props.history.push('/event/' + event.guid);
        console.log('handleEventClick', event);
        //alert('Event: ') + event;
        //alert('Coordinates: ');
        //alert('View: ');
    }

    handleEventAfterAllRender(view) {
        var lastDate = view.start.format();
        var lastView = view.type.trim();
        this.state.loading = false;
        //console.log('handleEventAfterAllRender existing:', this.props.calendar.lastDate, this.props.calendar.lastView);
        //console.log('handleEventAfterAllRender', lastDate, lastView);
        if (this.props.calendar.lastDate !== lastDate || this.props.calendar.lastView !== lastView) {
            console.log('handleEventAfterAllRender updating calendar settings');
            this.props.onUpdateCalendar(lastDate, lastView);
        }        
    }

    handleLoading(isLoading, view) {
        this.toggleOverlay();
        console.log('handleLoading', isLoading);
        //alert("handleLoading: " + isLoading);
        //this.state.loading = isLoading;
        //this.state.loading = false;
    }

    handleDropEvent(event) {
        console.log('moving event ' + event.guid + " start:" + event.start + " end:" + event.end);
        var start = new moment(event.start).format('YYYY-MM-DDTHH:mm:ss');
        var end = new moment(event.end).format('YYYY-MM-DDTHH:mm:ss');
        var movePatch = { start: start, end: end, type: event.type, title: event.title};
        console.log(JSON.stringify(movePatch));
//        var moveUrl = "http://localhost:3001/api/v0/events/" + event.guid;
        var moveUrl = "https://beisekerice.com/api/v0/events/" + event.guid;
        console.log(moveUrl);
        var response = fetch(moveUrl, {
            method: 'PUT',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
            },
            body: JSON.stringify(movePatch)
            }).then(
                console.log(response),
            );
    }

    handleSelection(start, end) {
        //alert('Online Ice rental for 2018-2019 coming soon.');
        //alert('Coordinates: ');
        //alert('View: ');
        this.props.history.push('/newEvent/' + start.format('YYYYMMDDHHmm') + '/' + end.format('YYYYMMDDHHmm'));
    }

//( event, delta, revertFunc, jsEvent, ui, view )
    handleEventResize(event) { 
        console.log('resizing event ' + event.guid + " start:" + event.start + " end:" + event.end);
        var start = new moment(event.start).format('YYYY-MM-DDTHH:mm:ss');
        var end = new moment(event.end).format('YYYY-MM-DDTHH:mm:ss');
        var movePatch = { start: start, end: end, type: event.type, title: event.title};
        console.log(JSON.stringify(movePatch));
//        var moveUrl = "http://localhost:3001/api/v0/events/" + event.guid;
        var moveUrl = "https://beisekerice.com/api/v0/events/" + event.guid;
        console.log(moveUrl);
        var response = fetch(moveUrl, {
            method: 'PUT',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
            },
            body: JSON.stringify(movePatch)
            }).then(
                console.log(response),
            );
    }
/*
    onUpdateCalendar(lastDate, lastView){
        console.log('onUpdateCalendar existing:', this.props.calendar.lastDate, this.props.calendar.lastView);
        console.log('onUpdateCalendar', lastDate, lastView);

        this.props.onUpdateCalendar(lastDate, lastView);
      }
*/

    toggleOverlay = () => {
        this.state.loading = !this.state.loading;
    };

      render() {
        return (
          <div id="example-component">
          <FullCalendar 
                 id = "calendar"
             header = {{
                left: 'prev,next,today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listWeek'
            }}
            footer = {{
                left: 'prev,next,today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listWeek'
            }}
            defaultDate = {this.props.calendar.lastDate || null}
            defaultView = {this.props.calendar.lastView || 'agendaWeek'}
            navLinks= {true} // can click day/week names to navigate views

            eventLimit= {true} // allow "more" link when too many events

            firstDay = {1}
            allDaySlot = {false}
            minTime = '08:00'
            slotLabelInterval = '01:00'
//            defaultView = 'agendaWeek'
            snapDuration = '00:15'
            editable= {false}
//            editable = {true}
            selectable = {true}
			selectHelper = {true}
            selectOverlap = {false}
            contentHeight = 'auto'
			/*allDaySlot: false,
			minTime: "08:00",
			slotLabelInterval: "01:00",
			snapDuration: "00:15",
			contentHeight: "auto",
			defaultView: 'agendaWeek',
			eventBorderColor: '#5e5220',
			eventColor: '#af972b',
			editable: false,
			eventOverlap: false,
			droppable: true,
			selectable: true,
			selectHelper: true,
			selectOverlap: false,*/
            //events = {this.state.events}	
            eventSources = {this.state.eventSources}
            visibleRange = {this.state.visibleRange}
            eventDrop = {this.handleDropEvent.bind(this)}
            select = {this.handleSelection.bind(this)}
            eventClick = {this.handleEventClick.bind(this)}
            eventResize = {this.handleEventResize.bind(this)}
            eventAfterAllRender = {this.handleEventAfterAllRender.bind(this)}
            loading = {this.handleLoading.bind(this)}
            showNonCurrentDates = {false}
            
        />
          </div>
        );
      }
}

const mapStateToProps = state => ({
    products: state.products,
    user: state.user,
    alert: state.alert,
    calendar: state.calendar
  });
  
  const mapActionsToProps = {
    onUpdateCalendar: updateSchedule
  };
  
  
  export default connect(mapStateToProps, 
    mapActionsToProps
    )(Calendar);

//export default Calendar;


// WEBPACK FOOTER //
// ./src/components/Calendar.js